import { render, staticRenderFns } from "./DonutChart79.vue?vue&type=template&id=4e56fccb&scoped=true&"
import script from "./DonutChart79.vue?vue&type=script&lang=js&"
export * from "./DonutChart79.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e56fccb",
  null
  
)

export default component.exports